/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Suspense, lazy } from "react";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";

const About = lazy(() => import("./components/About").then(m => ({ default: m.About })));
const Services = lazy(() => import("./components/Services").then(m => ({ default: m.Services })));
const Gallery = lazy(() => import("./components/Gallery").then(m => ({ default: m.Gallery })));
const Reviews = lazy(() => import("./components/Reviews").then(m => ({ default: m.Reviews })));
const Contact = lazy(() => import("./components/Contact").then(m => ({ default: m.Contact })));
const Footer = lazy(() => import("./components/Footer").then(m => ({ default: m.Footer })));
const CookieBanner = lazy(() => import("./components/CookieBanner").then(m => ({ default: m.CookieBanner })));
const LegalDocuments = lazy(() => import("./components/LegalDocuments").then(m => ({ default: m.LegalDocuments })));

export default function App() {
  return (
    <div className="bg-studio-dark min-h-screen text-zinc-100 font-sans antialiased selection:bg-studio-gold selection:text-black overflow-x-hidden">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-6 focus:py-3 min-h-[48px] flex items-center focus:bg-studio-gold focus:text-black focus:font-bold focus:rounded-md focus:outline-none focus:ring-4 focus:ring-white">
        Przejdź do głównej treści
      </a>
      <Navbar />
      <main id="main-content" tabIndex={-1} className="focus:outline-none">
        <Hero />
        <Suspense fallback={<div className="min-h-[800px] w-full flex items-center justify-center"><div className="w-8 h-8 rounded-full border-t-2 border-studio-gold animate-spin"></div></div>}>
          <About />
          <Services />
          <Gallery />
          <Reviews />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <CookieBanner />
        <LegalDocuments />
      </Suspense>
    </div>
  );
}
